import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SideNavComponent} from './side-nav/side-nav.component';
import {ScheduleComponent} from './schedule/schedule.component';
import {AppRoutingModule} from '../../app-routing.module';
import {PlayerModule} from '../player/player.module';
import {ChatComponent} from '../chat/chat.component';
import {ChatModule} from '../chat/chat.module';

@NgModule({
  declarations: [
    SideNavComponent,
    ScheduleComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    PlayerModule,
    ChatModule,
  ],
  exports: [SideNavComponent]
})
export class SideNavModule {
}
